import {
  Component,
  OnInit,
  ViewEncapsulation,
  ChangeDetectorRef,
  Input,
  SimpleChanges,
  ElementRef
} from '@angular/core';
import { LicensesService } from '../../services/licenses.service';
import { DEFAULT_LANGUAGE } from '../../constants';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarMessageService } from '@ngx-interact-ui/core';
@Component({
  selector: 'ph-licenses',
  templateUrl: './licenses.component.html',
  styleUrls: ['./licenses.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class LicensesComponent implements OnInit {
  @Input() public projectCode!: string;
  @Input() public projectName: string;
  @Input() public accessToken!: string;
  @Input() public language!: string;
  public licensesData: any;
  public isLoading = false;
  public allInactive = false;

  constructor(
    private licensesService: LicensesService,
    private snackbarMessageService: SnackbarMessageService,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
    private host: ElementRef
  ) { }

  public ngOnInit() {
    this.translate.setDefaultLang(DEFAULT_LANGUAGE);
    this.translate.use(DEFAULT_LANGUAGE);
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (this.projectCode && this.accessToken) {
    this.host.nativeElement.dispatchEvent(new CustomEvent('showLoader', {
      detail: { showLoader: true },
      bubbles: true,
      composed: true
    }));
    this.licensesService
      .getBuildingLicenses(this.projectCode, this.accessToken)
      .subscribe({
        next: (data) => {
          this.host.nativeElement.dispatchEvent(new CustomEvent('showLoader', {
            detail: { showLoader: false },
            bubbles: true,
            composed: true
          }));
          this.licensesData = data['licenses'];
          const now = new Date();
          this.allInactive = this.licensesData.length > 0 && this.licensesData.every(license => {
            const validUntil = license?.validUntilUtc ? new Date(license.validUntilUtc) : null;
            return !validUntil || validUntil < now;
          });

          this.isLoading = false;
          
          this.cdr.detectChanges();
        },
        error: (error) => {
          this.isLoading = false;
          this.host.nativeElement.dispatchEvent(new CustomEvent('showLoader', {
            detail: { showLoader: false },
            bubbles: true,
            composed: true
          }));
          console.error('Error fetching licenses:', error);
          this.translate.get("licenses.LICENSES_FAILED").subscribe(text => {
            this.snackbarMessageService.warning({
              message: text,
            });
          });
        },
      });
    }
    //Handle language changes from main app
    if (changes.language) {
      this.translate.use(changes.language.currentValue || DEFAULT_LANGUAGE);
    }
  }
}
